import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { DefeitoCatalogo, SeveridadeDefeito } from '../../types/qualidade';
import { defeitosCatalogoService } from '../../services';

const severidadeOptions: { label: string; value: SeveridadeDefeito }[] = [
  { label: 'Baixa', value: 'BAIXA' },
  { label: 'Média', value: 'MEDIA' },
  { label: 'Alta', value: 'ALTA' },
  { label: 'Crítica', value: 'CRITICA' },
];

const fields: ResourceField<DefeitoCatalogo>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
  { name: 'severidade', label: 'Severidade', type: 'select', options: severidadeOptions, required: true },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: [
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' },
    ],
    render: ({ value, onChange }) => (
      <div className="d-flex flex-column">
        <label className="form-label">Ativo</label>
        <select
          className="form-select"
          value={value === true ? 'true' : value === false ? 'false' : ''}
          onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value === 'true')}
        >
          <option value="">Selecione</option>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
    ),
  },
];

export const DefeitosCatalogoFormPage: React.FC = () => (
  <ResourceFormPage
    title="Defeito (catálogo)"
    description="Cadastre tipos de defeito para uso nas inspeções."
    fields={fields}
    service={defeitosCatalogoService}
    redirectPath="/admin/parametros/defeitos-catalogo"
    cancelPath="/admin/parametros/defeitos-catalogo"
  />
);
